// extracted by mini-css-extract-plugin
export default {"fdoTable":"app-react-portainer-settings-EdgeComputeView-SettingsFDO-SettingsFDO-module__fdo-table"};